module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/my_comment.b0e16.png";